/**
 * Input queue configuration shared between client and server
 * Ensures consistent input handling for client prediction and server simulation
 */
export const INPUT_CONFIG = {
  /**
   * Maximum number of inputs to queue per player
   * 4 = max useful (covers U-turn: UP → RIGHT → DOWN + 1 buffer)
   * Geometric constraint: only 4 directions exist
   */
  MAX_QUEUE_SIZE: 4,
  
  /**
   * Maximum age of inputs in ticks before expiry
   * Prevents stale inputs from affecting gameplay when snake is slow
   * 3 ticks = reasonable window for complex maneuvers
   */
  MAX_INPUT_AGE_TICKS: 20,
  
  /**
   * Game tick rate (ticks per second)
   * Both client prediction and server simulation should match this
   */
  TICK_RATE: 10,
  
  /**
   * Number of inputs to consume per tick
   * Set to 1 for consistent snake movement
   */
  INPUTS_PER_TICK: 1,
} as const;
